import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"more\"><path d=\"M593.115429 147.017143a81.115429 81.115429 0 1 0-162.230858 0 81.115429 81.115429 0 0 0 162.230858 0z m0 364.982857A81.115429 81.115429 0 1 0 430.811429 512 81.115429 81.115429 0 0 0 593.188571 512z m0 364.982857a81.115429 81.115429 0 1 0-162.230858 0 81.115429 81.115429 0 0 0 162.230858 0z\" p-id=\"14410\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol